module.exports = __webpack_public_path__ + "static/media/boss-bar-red-02.4242be11.png";